import Cookies from "js-cookie"
import {FullWidthContainer, Content} from "../../models/secondary-nav"
import {ExcludeFromValues} from "../../models/excludeFrom"
import {MASID_COOKIE_NAME, EXCLUDE_FROM_TYPE} from "../../config/constants"
import {screenIsBiggerOrEqualToLarge} from "../window"

const checkIfmasIdExists = (masId: string) => {
    const masIDCookie = Cookies.get(MASID_COOKIE_NAME)?.split("=")[1]
    return masIDCookie && masIDCookie.split("|").indexOf(masId) > -1
}

export const getPersonalisedSecondaryNavContent = (fullWidthContainer: FullWidthContainer): Content[] | null => {
    let content: Content[] = []
    const initialValue: Content[] = [{items: [], row: 0, title: ""}]
    const isScreenWidthLargeUp: ExcludeFromValues = screenIsBiggerOrEqualToLarge()
        ? EXCLUDE_FROM_TYPE.WIDEVIEW
        : EXCLUDE_FROM_TYPE.NARROWVIEW
    let excludeFrom = fullWidthContainer.excludeFrom ? fullWidthContainer.excludeFrom : null

    if (excludeFrom && excludeFrom.includes(isScreenWidthLargeUp as ExcludeFromValues)) return null

    content = fullWidthContainer?.personalizationItems?.reduce((acc, currObj, index) => {
        currObj.rules.forEach(rule => {
            excludeFrom = rule.excludeFrom || null
            const includesExcludeFrom = excludeFrom?.includes(isScreenWidthLargeUp as ExcludeFromValues)
            if (
                rule?.masId &&
                checkIfmasIdExists(rule.masId) &&
                rule?.items[0]?.items?.length > 0 &&
                !includesExcludeFrom
            ) {
                if (rule.items[0].title === null) {
                    acc[0].items.push(...rule?.items[0]?.items)
                    acc[0].row = index
                } else {
                    acc.push({
                        items: [...rule?.items[0]?.items],
                        row: index,
                        title: rule.items[0].title,
                    })
                }
            }
        })
        if (acc?.length > 1 && acc[0]?.items?.length === 0) acc.shift()
        return acc
    }, initialValue)

    return content?.length > 0 && content[0]?.items?.length > 0 ? content : null
}
